import styled from '@emotion/styled'
import { useAdministrationStateContext } from '../../components/state'
import ReactJson from 'react-json-view'
import { LabeledItem } from '../../components'
import { CdsDebugInfo } from './cds.types'

const Content = styled.div`
`

const ServiceUrl = styled.div`
    font-size: 10pt;
    margin: 0.5rem;
`
const style = {
    padding: '0.5rem 2rem',
    borderRadius: '3px',
    margin: '10px 0px'
}

export function CdsDebugView() {
    const { globalState: state } = useAdministrationStateContext()

    return <Content>
        {state.serverDebugInfo.length > 0 ?
            state.serverDebugInfo.map((info: CdsDebugInfo, index) => {
                return info && <Content key={index} style={style}>
                    <LabeledItem title='Service: '>
                        <ServiceUrl>
                            {info.serviceUrl}
                        </ServiceUrl>
                    </LabeledItem>
                    <ReactJson
                        name={false}
                        collapsed={true}
                        theme='rjv-default'
                        src={info}
                        collapseStringsAfterLength={15}
                        displayObjectSize={true}
                        enableClipboard={true}
                        indentWidth={4}
                        displayDataTypes={true}
                        iconStyle={'triangle'}
                    />
                </Content>
            }) :
            <div style={style}>Debug information is only available here after CDC check was run</div>
        }
    </Content>
}